<template>
  <div class="animated fadeIn">
    <b-row>
        <PageTitle></PageTitle>
      <filter-area
        @filterData="filterData()"
        @resetData="resetFilerAreaData()"
      >
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label for="code">{{$t('filterArea.label.code')}}</label>
              <b-form-input
                type="text"
                id="code"
                :placeholder="$t('filterArea.label.code')"
                v-model="filterArea.code">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="name">{{$t('filterArea.label.name')}}</label>
              <b-form-input
                type="text"
                id="name"
                :placeholder="$t('filterArea.label.name')"
                v-model="filterArea.name">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label for="code">{{$t('filterArea.label.codingSchema')}}</label>
              <v-select v-model="filterArea.codingSchema"  :options="codingSchemas">
                <template slot="option" slot-scope="option">
                  {{ option.code }} - {{option.label}}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </filter-area>
      <b-col lg="12">
        <b-card>
          <b-table
            :stacked="stacked"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="captions"
            :current-page="1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :per-page="perPage"
            @sort-changed="sortingChanged"
            :no-sort-reset="true"
            :no-local-sorting="true">
            <template slot="actions" slot-scope="data">
              <div class="btn-group" role="group">
                <router-link tag="button" class="btn btn-primary fa fa-search" v-b-tooltip.hover :title="$t('actions.show')"
                             :to="{name: 'doctypeShowRoute', params:{id: data.item.id}}">
                </router-link>
              </div>
            </template>
            <template slot="documentTypeCodingSchema" slot-scope="data">
              <b-badge variant="warning" class="mx-1">
                <router-link class="cat"
                             :to="{name: 'documentTypeCodingSchemaShowRoute', params:{id: data.item.documentTypeCodingSchema.id}}">
                  {{data.item.documentTypeCodingSchema.code}}
                </router-link>
              </b-badge>
            </template>
          </b-table>
          <div class="row">
            <div class="col-sm-4">
              <b-pagination :total-rows="rowCount" :per-page="perPage" v-model="currentPage" prev-text="Prec"
                            next-text="Succ"
                            hide-goto-end-buttons @input="fetchData(currentPage)"/>
            </div>
            <div class="col-sm-8"></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import DocumentTypeService from '@/services/DocumentTypeService'
  import i18n from '@/config/i18n'
  import FilterArea from '../../components/FilterArea'
  import vSelect from 'vue-select'
  import CodingSchemaService from "../../services/CodingSchemaService";

  const documentTypeService = DocumentTypeService.build();
  const codingSchemaService = CodingSchemaService.build();

  export default {
    name: 'DocTypeList',
    components: {
      PageTitle,
      FilterArea,
      vSelect
    },
    props: {
      stacked: {
        type: String,
        default: 'sm'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 7
      }
    },
    data: () => {
      return {
        fields: [
          {
            key: 'code',
            sortable: true,
            label: i18n.t('page.generic.code')
          },
          {
            key: 'label',
            sortable: true,
            label: i18n.t('page.generic.name')
          },
          {
            key: 'description',
            sortable: true,
            label: i18n.t('page.generic.description')
          },
          {
            key: 'documentTypeCodingSchema',
            sortable: true,
            label: i18n.t('title.codingSchema')
          },
          {
            key: 'actions',
            sortable: false,
            label: ''
          }
        ],
        currentPage: 1,
        tableData: [],
        tableTotalRows: 0,
        sortBy: 'code',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterArea: {
          code: null,
          name: null,
          codingSchema: null
        },
        codingSchemas:[],
      }
    },
    created() {
      // fetch the data when the view is created and the data is
      // already being observed
      this.fetchData(1)
      this.getCodingSchemas()
    },
    computed: {
      items: function () {
        const items = this.tableData;
        return Array.isArray(items) ? items : []
      },
      captions: function () {
        return this.fields
      },
      rowCount: function () {
        return this.tableTotalRows
      },
      CodingSchemaFilters: function(){
        if(this.filterArea.codingSchema !== null){
          return this.filterArea.codingSchema.code
        }
      }
    },
    methods: {
      async fetchData(currentPage) {
        this.tableData = [];
        let response = await documentTypeService.search({
          max: this.perPage,
          offset: (currentPage - 1) * this.perPage,
          sort: this.sortBy,
          order: (this.sortDesc ? 'desc' : 'asc'),
          code: this.filterArea.code,
          name: this.filterArea.name,
          codingSchema: this.CodingSchemaFilters
        });
        this.tableData = response.data;
        this.tableTotalRows = response.total
      },
      sortingChanged(ctx) {
        // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
        // ctx.sortDesc ==> true if sorting descending, false otherwise
        this.sortBy = ctx.sortBy;
        this.sortDesc = ctx.sortDesc;
        this.fetchData(this.currentPage)
      },
      getCodingSchemas() {
        codingSchemaService.search().then((data) => {
          this.codingSchemas = data;
        })
      },
      filterData(){
        this.fetchData(1)
      },
      resetFilerAreaData(){
        this.filterArea = {
          code: null,
          name: null,
          codingSchema: null
        }
        this.fetchData(1)
      }
    }
  }
</script>
